// GoogleGenerativeAI service - STUBBED OUT for VPSReporting
// This service is not used in VPSReporting, only Private LLM is used
import type { AIResponse, AIFixSteps, ChatSession } from '../types';

// Stub implementations - these will throw errors if accidentally called
export const analyzePartImagesForFault = async (): Promise<string> => {
  throw new Error('Gemini service not available in VPSReporting. Use Private LLM service instead.');
};

export const startChatSession = async (): Promise<{ chat: ChatSession; response: AIResponse }> => {
  throw new Error('Gemini service not available in VPSReporting. Use Private LLM service instead.');
};

export const continueChatSession = async (): Promise<AIResponse> => {
  throw new Error('Gemini service not available in VPSReporting. Use Private LLM service instead.');
};

export const getFixSteps = async (): Promise<AIFixSteps> => {
  throw new Error('Gemini service not available in VPSReporting. Use Private LLM service instead.');
};

export const getCauseDetails = async (): Promise<string> => {
  throw new Error('Gemini service not available in VPSReporting. Use Private LLM service instead.');
};

export const lookupDtcCode = async (): Promise<string> => {
  throw new Error('Gemini service not available in VPSReporting. Use Private LLM service instead.');
};